import React, { useContext } from 'react'
import { ScoreCardContext } from '../../store/scorecard-context'
import styles from './Styles.module.css'
import { ScoreCardOptions } from '../../types/interface'


const Options = ({options, questionIndex, sectionIndex}: any) => {

    const scorecardCtx = useContext(ScoreCardContext)

    const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>, i: number) => {
        let  cea = JSON.parse(JSON.stringify(scorecardCtx.customerEffortAssesment))
        cea.sections[0].questions[questionIndex].options.map((option: ScoreCardOptions) => {
            option.is_answer = false
        })
        cea.sections[sectionIndex].questions[questionIndex].options[i].is_answer = e.target.checked


        // To check if all sections reviewed
        // This is done to enable the Submit Review
        // let isAllAnswered = isAllQuestionAnswered(scores)
        // scorecardCtx.updateReviewedScore(isAllAnswered)

        scorecardCtx.updateCustomerEffortAssesment(cea)
        
    }
                             
    const optionsUI = options && options.map(({name, is_answer, score}: any, index: number) => {   
        return  <li key={`answer-${questionIndex}-${index}`} className={`d-flex align-items-center mb-0`}>
                    <input 
                        type="radio" 
                        name={`cea-answer-${questionIndex}`}
                        id={`cea-answer-${questionIndex}-${index}`}
                        className={`${styles.checkboxInput} btn-check`} 
                        checked={is_answer}
                        onChange={(e) => onChangeHandler(e, index)}
                    />
                    <label className={`m-0 me-2 ${styles.questionOption} ${is_answer ? `btn ${styles.selectedOption}` : ''}`} htmlFor={`cea-answer-${questionIndex}-${index}`}>{name}</label>
                </li>
    })

    return (
        <>
            { optionsUI }
        </>
    )
}

export default Options
